import React from 'react';

export const ShutterLeftFoldRight = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 105.4 58.3"
      width="111"
      {...props}
    >
      <path fill="#fff" d="M5.5.6h94.4v50.8H5.5z" />
      <path
        d="M99.9 52H5.5c-.4 0-.8-.3-.8-.6V.6c0-.3.4-.6.8-.6h94.4c.4 0 .8.3.8.6v50.8c0 .3-.3.6-.8.6zM6.3 50.8h92.9V1.2H6.3v49.6z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M5.5.6h94.4v50.8H5.5z" />
      <path
        d="M99.9 52H5.5c-.4 0-.8-.3-.8-.6V.6c0-.3.4-.6.8-.6h94.4c.4 0 .8.3.8.6v50.8c0 .3-.3.6-.8.6zM6.3 50.8h92.9V1.2H6.3v49.6z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M9.9 3.9h85.6V48H9.9z" />
        <path d="M95.5 48.6H9.9c-.4 0-.8-.3-.8-.6V3.9c0-.3.3-.6.8-.6h85.6c.4 0 .8.3.8.6V48c0 .4-.3.6-.8.6zm-84.8-1.1h84.1v-43H10.7v43z" />
      </g>
      <path
        d="M104.7 51.9H.7c-.4 0-.7-.2-.7-.6 0-.3.3-.6.7-.6h104c.4 0 .7.2.7.6 0 .4-.3.6-.7.6z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M5.3 1.3l27.1 6.3.2 49.9-27.3-6.8z" />
        <path
          d="M33 58.3L4.8 51.2V.5L32.9 7l.1 51.3zM5.8 50.2l26.3 6.6-.2-48.7L5.8 2v48.2z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.2 7.1l21.5 5.1v3.6L8.2 10.7z" />
        <path
          d="M30 16.2L7.9 11V6.8l22 5.2.1 4.2zM8.4 10.4l21 5v-2.9l-21-4.9v2.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.2 10.7l21.5 5.1v3.6L8.2 14.3z" />
        <path
          d="M30 19.7L7.9 14.5v-4.2L30 15.5v4.2zM8.4 14l21.1 5v-2.9l-21-5-.1 2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.2 14.3l21.5 5.1v3.5L8.2 17.8z" />
        <path
          d="M30 23.3L7.9 18.1v-4.2L30 19.1v4.2zM8.4 17.5l21.1 5v-2.9l-21.1-5v2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.2 17.8L29.7 23v3.6L8.2 21.4z" />
        <path
          d="M30 26.9L7.9 21.7v-4.2L30 22.7v4.2zM8.4 21.1l21.1 5v-2.9l-21.1-5v2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.2 21.4l21.5 5.2v3.5L8.2 25z" />
        <path
          d="M30 30.5L7.9 25.2V21L30 26.3v4.2zM8.4 24.7l21.1 5.1v-2.9l-21.1-5v2.8z"
          fill="#fff"
        />
        <path fill="#233762" d="M8.2 25l21.5 5.1v3.6L8.2 28.5z" />
        <path
          d="M30 34.1L7.9 28.8v-4.2L30 29.9v4.2zM8.4 28.3l21.1 5.1v-2.9L8.4 25.3v3z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M8.2 28.5l21.5 5.2.1 3.6-21.6-5.2z" />
          <path
            d="M30 37.7L7.9 32.4v-4.2L30 33.5v4.2zM8.4 31.8l21.1 5.1V34L8.4 28.9v2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M8.2 32.1l21.6 5.2v3.6L8.2 35.7z" />
          <path
            d="M30 41.3L7.9 35.9v-4.2L30 37.1v4.2zM8.4 35.4l21.1 5.1v-2.9L8.4 32.5v2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M8.2 35.7l21.6 5.2v3.6L8.2 39.2z" />
          <path
            d="M30 44.9L7.9 39.5v-4.2L30 40.7v4.2zM8.4 39l21.1 5.2v-2.9L8.4 36v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M8.2 39.3l21.6 5.3v3.6L8.2 42.8z" />
          <path
            d="M30 48.6L7.9 43.1v-4.2L30 44.3v4.3zm-21.6-6l21.1 5.2v-2.9L8.4 39.6v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M8.2 42.8l21.6 5.4v3.6L8.2 46.4z" />
          <path
            d="M30 52.2L7.9 46.7v-4.2L30 47.9v4.3zM8.4 46.1l21.1 5.2v-3L8.4 43.2v2.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M18.3 9.5l1.4.3v39.5l-1.4-.4z" />
      </g>
      <g>
        <path fill="#233762" d="M33.5 7.3l27.8-6.1v49.5l-27.8 6.8z" />
        <path
          d="M61.8 51.2L33 58.3V6.8L61.8.6v50.6zM34 56.8l26.8-6.6V2L34.1 7.8l-.1 49z"
          fill="#fff"
        />
        <path fill="#233762" d="M36.6 11.9l22-4.8v3.6l-22 4.8z" />
        <path
          d="M58.8 10.9l-22.6 5v-4.3l22.6-5v4.3zm-22 4.3l21.5-4.8V7.5l-21.5 4.7v3z"
          fill="#fff"
        />
        <path fill="#233762" d="M36.6 15.5l22-4.8v3.5l-22 5z" />
        <path
          d="M58.8 14.5l-22.6 5.1v-4.3l22.6-5v4.2zm-22 4.3L58.3 14v-3l-21.5 4.8v3z"
          fill="#fff"
        />
        <path fill="#233762" d="M36.6 19.2l22-5v3.6l-22 5z" />
        <path
          d="M58.8 18.1l-22.6 5.1v-4.3l22.6-5v4.2zm-22 4.3l21.5-4.9v-2.9l-21.5 4.8v3z"
          fill="#fff"
        />
        <path fill="#233762" d="M36.6 22.8l22-5v3.6l-22 5z" />
        <path
          d="M58.8 21.6l-22.6 5.1v-4.3l22.6-5.1v4.3zm-22 4.4l21.5-4.9v-2.9l-21.5 4.9V26z"
          fill="#fff"
        />
        <path fill="#233762" d="M36.6 26.4l22-5V25l-22 5z" />
        <path
          d="M58.8 25.2l-22.6 5.2v-4.3L58.8 21v4.2zm-22 4.4l21.5-4.9v-2.9l-21.5 4.9v2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M36.6 30l22-5v3.5l-22 5.1z" />
        <path
          d="M58.8 28.8L36.3 34v-4.3l22.6-5.2-.1 4.3zm-22 4.4l21.5-5v-2.9l-21.5 5v2.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M36.6 33.6l22-5.1v3.6l-22 5.1z" />
          <path
            d="M58.8 32.3l-22.6 5.3v-4.3l22.6-5.2v4.2zm-22 4.6l21.5-5V29l-21.5 5v2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M36.6 37.2l22-5.1v3.6l-22 5.2z" />
          <path
            d="M58.8 35.9l-22.6 5.3V37l22.6-5.3v4.2zm-22 4.6l21.5-5.1v-2.9l-21.5 5v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M36.6 40.9l22-5.2v3.5l-22 5.3z" />
          <path
            d="M58.8 39.5l-22.6 5.4v-4.3l22.6-5.3v4.2zm-22 4.6L58.3 39v-3l-21.5 5.1v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M36.6 44.5l22-5.3v3.6l-22 5.3z" />
          <path
            d="M58.8 43.1l-22.6 5.4v-4.3l22.6-5.4v4.3zm-22 4.6l21.5-5.2v-2.9l-21.5 5.1v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M36.6 48.1l22-5.3v3.6l-22 5.3z" />
          <path
            d="M58.8 46.6l-22.6 5.5v-4.3l22.6-5.4v4.2zm-22 4.7l21.5-5.2v-2.9l-21.5 5.2v2.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M47 9.6l1.5-.3v39.5l-1.5.4z" />
      </g>
      <g>
        <path fill="#233762" d="M67 7.3l32.9-6.1v49.5L67 57.5z" />
        <path
          d="M100.5 51.2l-34.1 7.1V6.8L100.5.6v50.6zm-32.9 5.6l31.7-6.6V2L67.6 7.8v49z"
          fill="#fff"
        />
        <path fill="#233762" d="M70.5 11.9l26.1-4.8v3.6l-26.1 4.8z" />
        <path
          d="M96.9 10.9l-26.7 5v-4.3l26.7-5v4.3zm-26 4.3l25.5-4.8V7.5l-25.5 4.7v3z"
          fill="#fff"
        />
        <path fill="#233762" d="M70.5 15.5l26.1-4.8v3.5l-26.1 5z" />
        <path
          d="M96.9 14.5l-26.7 5.1v-4.3l26.7-5v4.2zm-26 4.3L96.3 14v-3l-25.5 4.8.1 3z"
          fill="#fff"
        />
        <path fill="#233762" d="M70.5 19.2l26.1-5v3.6l-26.1 5z" />
        <path
          d="M96.9 18.1l-26.7 5.1v-4.3l26.7-5v4.2zm-26 4.3l25.5-4.9v-2.9l-25.5 4.8v3z"
          fill="#fff"
        />
        <path fill="#233762" d="M70.5 22.8l26.1-5v3.6l-26.1 5z" />
        <path
          d="M96.9 21.6l-26.7 5.1v-4.3l26.7-5.1v4.3zm-26 4.4l25.5-4.9v-2.9l-25.5 4.9V26z"
          fill="#fff"
        />
        <path fill="#233762" d="M70.5 26.4l26.1-5V25l-26.1 5z" />
        <path
          d="M96.9 25.2l-26.7 5.2v-4.3L96.9 21v4.2zm-26 4.4l25.5-4.9v-2.9l-25.5 4.9v2.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M70.5 30l26.1-5v3.5l-26.1 5.1z" />
        <path
          d="M96.9 28.8L70.2 34v-4.3l26.7-5.2v4.3zm-26 4.4l25.5-5v-2.9l-25.5 5v2.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M70.5 33.6l26.1-5.1v3.6l-26.1 5.1z" />
          <path
            d="M96.9 32.3l-26.7 5.3v-4.3l26.7-5.2v4.2zm-26 4.6l25.5-5V29l-25.5 5v2.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M70.5 37.2l26.1-5.1v3.6l-26.1 5.2z" />
          <path
            d="M96.9 35.9l-26.7 5.3V37l26.7-5.3v4.2zm-26 4.6l25.5-5.1v-2.9l-25.5 5v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M70.5 40.9l26.1-5.2v3.5l-26.1 5.3z" />
          <path
            d="M96.9 39.5l-26.7 5.4v-4.3l26.7-5.3v4.2zm-26 4.6L96.3 39v-3l-25.5 5.1.1 3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M70.5 44.5l26.1-5.3v3.6l-26.1 5.3z" />
          <path
            d="M96.9 43.1l-26.7 5.4v-4.3l26.7-5.4v4.3zm-26 4.6l25.5-5.2v-2.9l-25.5 5.1v3z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M70.5 48.1l26.1-5.3v3.6l-26.1 5.3z" />
          <path
            d="M96.9 46.6l-26.7 5.5v-4.3l26.7-5.4v4.2zm-26 4.7l25.5-5.2v-2.9l-25.5 5.2v2.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M82.9 9.6l1.7-.3v39.5l-1.7.4z" />
      </g>
    </svg>
  );
};
